/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")


  
    
export interface API54111Item {
  
  /**  */
  id?: number;
  
  /** 任务标题 */
  taskTitle?: string;
  
  /** 计划开始时间yyyy-MM-ddHH:mm */
  startTime?: any;
  
  /** 计划完成时间yyyy-MM-ddHH:mm */
  endTime?: any;
  
  /** 任务创建人发起人 */
  creator?: string;
  
  /** 任务发起者姓名 */
  creatorName?: string;
  
  /** 任务状态(1:未开始;2:进行中;3:已关闭;5:已完成) */
  taskStatusName?: string;
  
  /** 任务状态(1:未开始;2:进行中;3:已关闭;5:已完成) */
  taskStatus?: number;
  
};
    
  



export interface API54111Req {
  
  /** 搜索关键词 */
  keywords?: string;
    
  /** 关联类型：前置任务=pre_task，关联任务=link_task */
  linkType?: string;
    
  /** 任务ID */
  taskId?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API54111Res {
  /** T  */
  list?: API54111Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 54111 任务搜索

export interface IUseGetAPI54111Return {
  /** 任务搜索: 接口请求状态 */
  isAPI54111Loading: boolean;
  /** 任务搜索: 接口请求返回数据 */
  dataAPI54111: API54111Res;
  /**  任务搜索: 接口数据请求方法 */
  fetchAPI54111Data:  (inputs: API54111Req, config?: YWRequestConfig) => Promise<API54111Res>;
  /** 任务搜索: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI54111 = ():IUseGetAPI54111Return => {
  let isMount = true;
  const [isAPI54111Loading, setIsAPI54111Loading] = useState(false);
  const [dataAPI54111, setDataAPI54111] = useState<API54111Res>({} as API54111Res);
  const requestUrl = `${basePath}/team-work/workTask/listTaskSearch`;

  const fetchAPI54111Data = async (inputs: API54111Req, config?: YWRequestConfig): Promise<API54111Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API54111Req>) || {}) as API54111Req;
    
  
    if ( isMount ) {
      setIsAPI54111Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API54111Res>(`${basePath}/team-work/workTask/listTaskSearch?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI54111(res || {} as API54111Res);
        setIsAPI54111Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI54111Loading(false);
      }
      return false as unknown as API54111Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI54111Loading,
    dataAPI54111,
    fetchAPI54111Data,
    requestUrl,
  }
}

